<template>
  <v-container class='' fluid>
    <div class='intro'>
      <div class='hello my-auto'>
        <h5 :class="{'text-center': true}">HELLO, WORLD.</h5>
        <h1 class='name mt-2 mb-4'>I'm Dominic</h1>

        <p class='text-center'>
          <span >|</span>
          the engineer of your dreams
          <span >|</span>
          <!-- PROGRAMMER
          <span >|</span> -->
        </p>


        <v-btn class='about py-6 px-8'
        color='#ebebeb'
        type='button'
        text
        href='#about'>
          MORE ABOUT ME
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </div>

      <div id='about'>
        <v-btn color='white'
        href='https://github.com/dombrga'
        target='_blank'
        icon
        x-large>
          <v-icon x-large>mdi-github</v-icon>
        </v-btn>
        <span class='mx-2'></span>
        <v-btn color='white' 
        href='https://www.linkedin.com/in/dominic-barga/'
        target='_blank'
        icon
        x-large>
          <v-icon x-large>mdi-linkedin</v-icon>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data: (vm) => ({
    isSmall: !vm.$vuetify.breakpoint.xs
  }),
  watch: {
    '$vuetify.breakpoint.xs': function(val) {
      // console.log('breakpoint', val, this.$vuetify.breakpoint.width)
      if(val) {
        this.isSmall = false
        return
      }

      this.isSmall = true
    },
  },
}
</script>

<style scoped>

h1 {
  font-family: 'Poppins', sans-serif;
  font-size: 36px;
  /* font-size: 5vw; */
  font-weight: 700;
  line-height: 1em;
}

h5 {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1.5px;
}

p {
  font-family: 'Lora', serif;
  font-size: 12px;
  font-weight: 400;

  line-height: 25px;
  letter-spacing: 4px;
}

.about.v-btn {
  font-family: 'Poppins', sans-serif;

  letter-spacing: 2px;
  border: 3px solid #5f5f5f;
  margin-top: 30px;
}

.container {
  color: #ebebeb;
  background-color: #111025;
  text-align: center;

  height: 100vh;
  padding: 0 10vw;
}

.intro {
  height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}



@media (min-width: 960px) {
  .name {
    font-size: 4rem;
  }
}
</style>